import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type UiFlowLabelTone = 'default' | 'muted' | 'strong';

@Component({
  selector: 'ui-flow-label',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span class="ui-flow-label" [class]="'ui-flow-label--' + tone()">{{ text() }}</span>`,
  styles: `
    :host {
      display: block;
      box-sizing: border-box;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      text-align: center;
    }
    .ui-flow-label {
      display: block;
      font-family: var(--font-sans, inherit);
      font-size: var(--ui-flow-label-font-size, 0.8125rem);
      line-height: 1.35;
      color: #1e293b;
      text-align: center;
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;
    }
    .ui-flow-label--muted {
      color: #64748b;
      font-size: var(--ui-flow-label-font-size, 0.75rem);
    }
    .ui-flow-label--strong {
      font-weight: 650;
      color: #1e293b;
    }
  `,
})
export class UiFlowLabelComponent {
  readonly text = input.required<string>();
  readonly tone = input<UiFlowLabelTone>('default');
}
